 export class AgendaAtividade{
    public AtividadeId: number;
    public HoraInicioAtividade: string;
    public Duracao: string;
    public Tipo: number;
    public Color: string;
    public SiglaSala: string;
    public DescritivoSala: string;
 }
 export class Agenda{
    public Dia: string;
    public Atividades: AgendaAtividade[];
 }
 


// WEBPACK FOOTER //
// ./src/models/agenda.model.ts